'use client';

import { Button } from '@/components/ui/button';
import { IconDatabaseOff } from '@tabler/icons-react';

export function SourcesEmptyState() {
  return (
    <div className="border rounded-lg bg-card p-12 text-center">
      <IconDatabaseOff className="size-12 text-muted-foreground/50 mx-auto mb-4" />
      <p className="text-lg font-medium mb-1">No sources configured</p>
      <p className="text-sm text-muted-foreground mb-6">
        Add a source to start indexing projects.
      </p>
      <Button variant="outline" size="sm" disabled>
        Add a source
      </Button>
    </div>
  );
}
